import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/web/src/app/data-deletion/DataDeletionContent.tsx");
